<template>
<inertia-head title="Affiliate Contest" />
<div class="bg-trc-main">
	<div class="bg-black-25">
		<div class="content text-center">
			<div class="py-0 mb-3">
				<h1 class="fw-bold text-white mb-2">
				Affiliate Contest
				</h1>
			</div>
		</div>
	</div>
</div>
<div class="content">
	<div v-if="affContest.length>0">
		<div class="block block-rounded border border-warning mb-5">
			<div class="content text-center">
				<div class="py-0">
					<h3 class="fw-bold mb-2">{{affContest[0].title}}</h3>
					<h5 class="fw-bold mb-2">DATE: {{affContest[0].date_contest}}</h5>
					<h2 class="h5 fw-normal">
					<div v-html="affContest[0].description"></div>
					</h2>
					<div class="table-responsive">
						<table class="table">
							<thead>
								<tr>
									<th>Monthly</th>
									<th>Quarterly</th>
									<th>Semi-annual</th>
									<th>Annual</th>
									<th>2 Years</th>
									<th>TOTAL</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{{affContestList.month1}}</td>
									<td>{{affContestList.month3}}</td>
									<td>{{affContestList.month6}}</td>
									<td>{{affContestList.month12}}</td>
									<td>{{affContestList.month24}}</td>
									<td>{{affContestList.total}}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="table-responsive mb-2">
						<h3 class="text-center">Points Breakdown</h3>
				
						<table class="table">
							<thead>
								<tr>
									<th>Payment Mode</th>
									<th>Gold Membership</th>
									<th>Diamond Membership</th>
									<th>Platinum Membership</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>Monthly</td>
									<td>1 Point</td>
									<td>2 Points</td>
									<td>4 Points</td>
								</tr>
								<tr>
									<td>Quarterly</td>
									<td>2.5 Point</td>
									<td>5 Points</td>
									<td>10 Points</td>
								</tr>
								<tr>
									<td>Semi-annual</td>
									<td>5 Point</td>
									<td>10 Points</td>
									<td>20 Points</td>
								</tr>
								<tr>
									<td>Annual</td>
									<td>10 Point</td>
									<td>20 Points</td>
									<td>40 Points</td>
								</tr>
								<tr>
									<td>2 Years</td>
									<td>20 Point</td>
									<td>40 Points</td>
									<td>80 Points</td>
								</tr>
								<tr>
									<td>3 Years</td>
									<td>30 Point</td>
									<td>60 Points</td>
									<td>120 Points</td>
								</tr>
							</tbody>
							<!-- <tbody>
												<tr>
																	<td>Monthly</td>
																	<td>2 Points</td>
																	<td>4 Points</td>
																	<td>8 Points</td>
												</tr>
												<tr>
																	<td>Quarterly</td>
																	<td>5 Points</td>
																	<td>10 Points</td>
																	<td>20 Points</td>
												</tr>
												<tr>
																	<td>Semi-annual</td>
																	<td>10 Points</td>
																	<td>20 Points</td>
																	<td>40 Points</td>
												</tr>
												<tr>
																	<td>Annual</td>
																	<td>20 Points</td>
																	<td>40 Points</td>
																	<td>80 Points</td>
												</tr>
												<tr>
																	<td>2 Years</td>
																	<td>40 Points</td>
																	<td>80 Points</td>
																	<td>160 Points</td>
												</tr>
							</tbody> -->
						</table>
					</div>
				</div>
			</div>
		</div>
		<div class="block block-rounded">
			<div class="text-center">
				<img src="/media/images/trc-contest-poster-malaysia.jpg" class="img img-fluid mt-5">
			</div>
			<div class="block-header">
				<div class="block-title text-center"><h3>Top 10 Qualifiers for our {{affContest[0].title}} Affiliate Contest</h3></div>
			</div>
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<table class="table">
						<thead>
							<tr>
								<!-- <th>Rank</th> -->
								<th>Name</th>
								<th class="text-end">Points</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(topaff,index) in topTenAff">
								<!-- <td>{{(index+1)}}</td> -->
								<td>{{topaff.username}} {{(topaff.fname)}} <span v-if="topaff.lname!=''">{{topaff.lname}}.</span></td>
								<td class="text-end">{{topaff.pts}}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="block block-rounded">
			
			<div class="block-header">
				<div class="block-title text-center mt-5">
					<h2>Affiliate Contest Terms and Conditions</h2>
				</div>
			</div>
			<div class="block-content block-content-full">
				
				<h4>1. Contest Overview</h4>
				<p>These terms and conditions outline the rules and regulations for participation in theTruly Rich Club Affiliate Contest (hereafter referred to as the "Contest"). By entering the Contest, affiliates agree to comply with these terms and conditions.</p>
				<h4>2. Eligibility</h4>
				<ul>
					<li>The Contest is open to all active members of the Truly Rich Club who are in good standing.</li>
					<li>Participants must be at least 18 years of age or the age of majority in their jurisdiction, whichever is older.</li>
					<li>Employees of Truly Rich Club, its affiliates, subsidiaries, advertising and promotion agencies, and their immediate family members are not eligible to participate.</li>
				</ul>
				<h4>3. Contest Period</h4>
				<p>The Contest begins on October 1, 2024 and ends on March 31, 2025 ("Contest Period"). All referrals must be received by March 31, 2025 to be eligible.</p>
				<h4>4. How to Enter</h4>
				<ul>
					<li>To enter the Contest, affiliates must generate successful referrals through their unique affiliate link during the Contest Period.</li>
					<li>Affiliates will earn points based on the successful referrals they generate. Each successful referral will have an equivalent point value assigned byTruly Rich Club as seen above this page.</li>
				</ul>
				<h4>5. Prizes</h4>
				<ul>
					<li>The prizes for the Contest are as follows:</li>
					<li>
						<ul>
							<li>First Prize: Trip to Kuala Lumpur, Malaysia</li>
							<li>Second Prize: Trip to Bohol</li>
							<li>Third Prize: Staycation in Manila</li>
						</ul>
					</li>
				</ul>
				<ul>
					<li>Travel prizes will only include roundtrip airfare (First and second prize only), accommodation, and breakfast. All other expenses, including but not limited to meals, transportation, and incidentals, are the responsibility of the winner.</li>
					<li>Prizes are non-transferable and cannot be sold. No cash alternatives will be offered, but if the affiliate prefers a cash prize, the Truly Rich Club reserves the right to determine the value of the said prize.</li>
					<li>Winners of out-of-country trips with visa requirements are responsible for applying and paying for their own visas.</li>
					<li>Truly Rich Club reserves the right to substitute any prize with another of equivalent value without giving notice.</li>
					<li>All winners must select the prize they want to avail along with all the necessary details within 30 days of the contest ending.</li>
					<li>A winner can qualify multiple times for all prizes depending on the points accumulated. For example, if a participant reaches the required points multiple times, they are eligible to receive multiple prizes.</li>
				</ul>
				<h4>6. Winner Selection and Notification</h4>
				<ul>
					<li>Winners will be selected based on the total number of points accumulated during the Contest Period.</li>
					<li>The winners will be notified via email or call within 7 days after the Contest Period ends.</li>
					<li>If a winner cannot be contacted or does not claim the prize within 30 days of notification,Truly Rich Club reserves the right to withdraw the prize and select a replacement winner.</li>
				</ul>
				<h4>7. Publicity</h4>
				<p>By participating in the Contest, participants agree to the use of their name, likeness, and entry for promotional purposes without additional compensation, unless prohibited by law.</p>
				<h4>8. General Conditions</h4>
				<ul>
					<li>Truly Rich Club reserves the right to cancel, suspend, or modify the Contest if any fraud, technical failures, or other factors beyondTruly Rich Club's reasonable control impair the integrity of the Contest, as determined by Truly Rich Club in its sole discretion.</li>
					<li>Truly Rich Club reserves the right to disqualify any individual who tampers with the entry process or the operation of the Contest or who is otherwise in violation of these terms and conditions.</li>
					<li>Affiliates must follow the existing affiliate agreement at all times, which can be found at this <a href="https://members.trulyrichclub.com/member/affiliate-program/agreement-and-policies" target="_blank">link</a>.</li>
				</ul>
				<h4>9. Limitation of Liability</h4>
				<ul>
					<li>By entering the Contest, participants agree to release and hold harmless Truly Rich Club, its affiliates, and their respective officers, directors, employees, and agents from any liability, illness, injury, death, loss, litigation, claim, or damage that may occur, directly or indirectly, whether caused by negligence or not, from such participant’s participation in the Contest and/or his/her acceptance, possession, use, or misuse of any prize or any portion thereof.</li>
					<li>Truly Rich Club will not be responsible for any tax liability incurred by participants. It is the sole responsibility of the winners to determine and pay any applicable taxes and to comply with any and all applicable tax laws.</li>
				</ul>
				<h4>10. Governing Law</h4>
				<p>The Contest and these terms and conditions are governed by the laws of the Republic of the Philippines, without regard to its conflict of laws principles.</p>
				<h4>11. Privacy</h4>
				<p>Personal information collected from participants will be used by Truly Rich Club for the purpose of administering the Contest and may also be used to provide participants with information about Truly Rich Club's products and services.</p>
				<h4>12. Acceptance of Terms and Conditions</h4>
				<p>By participating in the Contest, affiliates automatically agree to these terms and conditions.</p>
				<p>For any questions or concerns regarding these terms and conditions, please contact us at support@trulyrichclub.com</p>
			</div>
		</div>
	</div>
	<div v-if="affContest.length<=0" class="block block-rounded">
		<div class="block-content block-content-full">
			<p class="m-0 h4 text-danger">Get ready, affiliates! Something big is coming your way, and we can't wait to unveil it. We're cooking up an epic contest with amazing rewards and opportunities just for you.</p>
		</div>
	</div>
</div>
</template>
<script>
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());
gtag('config', window.gtag_id);
	
import { watch, onMounted } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import { createToaster } from '@meforma/vue-toaster'
import { useForm } from '@inertiajs/inertia-vue3'
export default {
	props:{
																		flash 				: Object,
														affContest 			: Object,
										affContestList 		: Object,
														topTenAff 			: Object,
	},
	layout: AuthLayout,
	setup(props) {
		const toast = createToaster();
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}
			
		})
		return{
			
		}
	},
}
</script>